// src/pages/usa/USA.js
import '../../App.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import StateButton from '../../components/StateButton';
import GoSearchBack from "../../components/BackSearchGo";
import ContactPopup from "../../components/ContactPopup";
import React, { useState } from "react";
import './USA.css';

import { useNavigate } from "react-router-dom";

export default function USA() {
  const navigate = useNavigate();

  // ⭐ Popup state — required for opening/closing the popup
  const [open, setOpen] = useState(false);

  const states = [
    // ... your states list stays exactly the same

    { name: "Alabama", visited: false },
    { name: "Alaska", visited: false },
    { name: "American Samoa", visited: false },
    { name: "Arizona", visited: true, page: "/travel/arizona" },
    { name: "Arkansas", visited: false },
    { name: "California", visited: false },
    { name: "Colorado", visited: true, page: "/travel/colorado" },
    { name: "Connecticut", visited: false },
    { name: "Delaware", visited: false },
    { name: "Florida", visited: false },
    { name: "Georgia", visited: false },
    { name: "Guam", visited: false },
    { name: "Hawaii", visited: false },
    { name: "Idaho", visited: true, page: "/travel/idaho" },
    { name: "Illinois", visited: false },
    { name: "Indiana", visited: false },
    { name: "Iowa", visited: false },
    { name: "Kansas", visited: false },
    { name: "Kentucky", visited: false },
    { name: "Louisiana", visited: false },
    { name: "Maine", visited: false },
    { name: "Maryland", visited: false },
    { name: "Massachusetts", visited: false },
    { name: "Michigan", visited: false },
    { name: "Minnesota", visited: false },
    { name: "Mississippi", visited: false },
    { name: "Missouri", visited: false },
    { name: "Montana", visited: false },
    { name: "Nebraska", visited: false },
    { name: "Nevada", visited: true, page: "/travel/nevada" },
    { name: "New Hampshire", visited: false },
    { name: "New Jersey", visited: false },
    { name: "New Mexico", visited: false },
    { name: "New York", visited: false },
    { name: "North Carolina", visited: false },
    { name: "North Dakota", visited: false },
    { name: "Ohio", visited: false },
    { name: "Oklahoma", visited: false },
    { name: "Oregon", visited: true, page: "/travel/oregon" },
    { name: "Pennsylvania", visited: false },
    { name: "Puerto Rico", visited: true, page: "/travel/puertorico" },
    { name: "Rhode Island", visited: false },
    { name: "South Carolina", visited: false },
    { name: "South Dakota", visited: true, page: "/travel/southdakota" },
    { name: "Tennessee", visited: false },
    { name: "Texas", visited: false },
    { name: "U.S. Virgin Islands", visited: false },
    { name: "Utah", visited: true, page: "/travel/utah" },
    { name: "Vermont", visited: false },
    { name: "Virginia", visited: false },
    { name: "Washington", visited: false },
    { name: "West Virginia", visited: false },
    { name: "Wisconsin", visited: false },
    { name: "Wyoming", visited: false }
  ];

  return (
    <>
      {/* ⭐ Header */}
<Header />

{/* ⭐ Correct Back/Search/Go for USA → back to world map */}
<div className="searchbar-top-container">
  <GoSearchBack />
</div>

{/* ⭐ USA content with translucent map */}
<div
  className="usa-container"
  style={{
    backgroundImage: "url('/images/usa/USA.png')",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    minHeight: "100vh",
  }}
>

        <div className="legend">
          <span className="legend-blue">Blue = Visited Places</span>
          <span className="legend-green">Green = Places To Visit</span>
        </div>

                <div className="usa-grid">
          {states.map((st) => (
            <StateButton
              key={st.name}
              label={st.name}
              visited={st.visited}
              onClick={() => st.visited && navigate(st.page)}
            />
          ))}
        </div>
      </div>

      {/* Centered email button */}
      <div className="email-wrapper">
        <button
          className="email-link"
          onClick={() => setOpen(true)}
        >
          contact@thefindingspot.com
        </button>
      </div>

      {/* Popup */}
      <ContactPopup
        isOpen={open}
        onClose={() => setOpen(false)}
      />

      <Footer />
    </>
  );
}
